// src/app/shared/shared.module.ts
import { Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

//import { ErrorHandler } from '@angular/core'; //this is not a module but a service!
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule as NgxTooltipModule} from 'ngx-bootstrap/tooltip';
import { LaddaDirective } from '../../app/components/common/spinners/spiner-button/cust-ladda.directive'; 

import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule, DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule as KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { TooltipModule as KendoTooltipModule } from '@progress/kendo-angular-tooltip'
import { UploadModule } from '@progress/kendo-angular-upload';

/**** rail360 imports ****/
import { EmailSendToIntacctModule } from '../components/common/email-send-to-intacct/email-send-to-intacct.module';
import { LegendModule } from '../components/common/legend/legend.module';
import { NotificationModule } from '../components/common/notification/notification.module'; 
import { SearchFacetModule } from '../components/common/search-facets/search-facet.module'; 
import { SendAccrualToIntacctModule } from '../components/send-accrual-general-journal-to-intacct/send-accrual-to-intacct.module'; 
import { SendArToIntacctModule } from '../components/common/send-ar-to-intacct/send-ar-to-intacct.module';
import { SendToIntacctModule } from '../components/common/send-to-intacct/send-to-intacct.module';
import { SidePanelModule } from '../components/common/side-panel/side-panel.module';

// Importing shared components, directives, and pipes
import { OrderByPipe } from './orderBy.pipe';
import { DateOnlyPipe } from './date-only.pipe';
import { last } from 'lodash';

@NgModule({
  declarations: [
    OrderByPipe,
    DateOnlyPipe,
    LaddaDirective, // Custom directive for loading buttons
  ],
  imports: [
    BsDropdownModule.forRoot(), 
    ModalModule.forRoot(), 
    CommonModule,
    RouterModule,
    DateInputsModule,
    FormsModule,
    ReactiveFormsModule,
    PopupModule,
    ButtonsModule,
    DropDownsModule,
    DropDownListModule,
    DialogModule,
    InputsModule,
    ExcelModule,
    GridModule,
    PDFModule,
    PDFExportModule,
    NgxTooltipModule,
    KendoTooltipModule,
    ProgressBarModule,
    KENDO_LAYOUT, 
    NumericTextBoxModule,
    ScrollViewModule,
    UploadModule,
    ChartsModule,
    GaugesModule,
    NgSelectModule,
    
    EmailSendToIntacctModule,
    LegendModule,
    NotificationModule,
    SearchFacetModule,
    SendArToIntacctModule,
    SendAccrualToIntacctModule,
    SendToIntacctModule,
    SidePanelModule,
    ],
  exports: [
    // Re-export common Angular modules so you don’t have to import them repeatedly
    CommonModule,
    RouterModule,
    BsDropdownModule,
    ModalModule,
    DateInputsModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    DropDownsModule,
    DropDownListModule,
    DialogModule,
    InputsModule,
    NumericTextBoxModule,
    ExcelModule,
    GridModule,
    PDFModule,
    PDFExportModule,
    PopupModule,
    NgxTooltipModule,
    KendoTooltipModule,
    ProgressBarModule,
    ChartsModule,
    GaugesModule,
    KENDO_LAYOUT, 
    ScrollViewModule,
    UploadModule,
    NgSelectModule,
    
    EmailSendToIntacctModule,
    LegendModule,
    NotificationModule,
    SearchFacetModule,
    SendArToIntacctModule,
    SendAccrualToIntacctModule,
    SendToIntacctModule,
    SidePanelModule,

    OrderByPipe,
    DateOnlyPipe,
    LaddaDirective, // Custom directive for loading buttons
  ]
})
export class SharedModule { }
